module.exports = __webpack_public_path__ + "img/gofintech.4258a60a.png";